export default {
  SET_ERROR_MESSAGE: '@AUTH_GATEWAY/ERRORS/SET_ERROR_MESSAGE',
};
